import PopupProvider from '../../../../../providers/PopupProvider';
import httpWrap from '../../../../procedures/http-wrap';
import action from '../../../abstract/action.js';

const handle = async (
  {
    $vs,
    item,
    model: {
      api: {
        show,
      },
    },
  },
) => {
  PopupProvider
    .setIsActive(true)
    .setTitle('Podgląd operacji')
    .setContent(await httpWrap({ $vs, action: show })(item));
};

export default action({
  label: 'Podgląd',
  icon: 'FileIcon',
  main: () => false,
  handle,
});
